import { Components, Theme } from "@mui/material";

export const MuiTextField: Components<Omit<Theme, "MuiTextField">>["MuiTextField"] =
  {
    styleOverrides: {
      root: ({ theme: { shape }, ownerState }) => ({
        borderRadius: shape.borderRadius,
        backgroundColor:
          ownerState.color === "secondary"
            ? "#F5F5F5"
            : ownerState.variant === "standard"
              ? "none"
              : "#fff",

        "&.Mui-error": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#EF5350",
          },
        },

        "&.Mui-disabled": {
          "& .MuiOutlinedInput-notchedOutline": {
            opacity: 0.2,
          },
        },
      }),
    },
  };
